'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024156 from "./presto.types$$anon$156.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dEmail$002dPayload$0024 from "./presto.types$-Two-Factor-Auth-Email-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthPayload$$anon$155() {
  this.cbW = null;
  this.cbO = null;
  this.cbP = false;
  this.cbX = null;
  this.cbY = false;
  this.cc1 = null;
  this.cbU = null;
  this.cbV = false;
  this.cbQ = null;
  this.cbR = false;
  this.cbS = null;
  this.cbT = false;
  this.cbZ = false;
  this.cc0 = false;
  this.cbW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.cc1 = "TwoFactorAuthEmailPayload";
}
export { $c_Lpresto_types$TwoFactorAuthPayload$$anon$155 as $c_Lpresto_types$TwoFactorAuthPayload$$anon$155 };
$p = $c_Lpresto_types$TwoFactorAuthPayload$$anon$155.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthPayload$$anon$155;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthPayload$$anon$155() {
}
export { $h_Lpresto_types$TwoFactorAuthPayload$$anon$155 as $h_Lpresto_types$TwoFactorAuthPayload$$anon$155 };
$h_Lpresto_types$TwoFactorAuthPayload$$anon$155.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.cbW;
});
$p.M = (function() {
  if ((!this.cbP)) {
    this.cbO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.cbP = true;
  }
  return this.cbO;
});
$p.O = (function() {
  if ((!this.cbY)) {
    this.cbX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.cbY = true;
  }
  return this.cbX;
});
$p.E = (function() {
  return this.cc1;
});
$p.t = (function() {
  if ((!this.cbV)) {
    this.cbU = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cbV = true;
  }
  return this.cbU;
});
$p.N = (function() {
  if ((!this.cbR)) {
    this.cbQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.cbR = true;
  }
  return this.cbQ;
});
$p.Q = (function() {
  if ((!this.cbT)) {
    this.cbS = new $j_presto$002etypes$0024$0024anon$0024156.$c_Lpresto_types$$anon$156();
    this.cbT = true;
  }
  return this.cbS;
});
$p.v = (function() {
  if ((!this.cc0)) {
    this.cbZ = false;
    this.cc0 = true;
  }
  return this.cbZ;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee167) => ((p) => \u03b4scrutinee167.cG3(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dEmail$002dPayload$0024.$m_Lpresto_types$TwoFactorAuthEmailPayload$())));
});
var $d_Lpresto_types$TwoFactorAuthPayload$$anon$155 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthPayload$$anon$155, "presto.types$TwoFactorAuthPayload$$anon$155", ({
  a2J: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$TwoFactorAuthPayload$$anon$155 as $d_Lpresto_types$TwoFactorAuthPayload$$anon$155 };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Payload$$anon$155.js.map
